import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './auth';
import contactReducer from './contact';

const rootReducer = combineReducers({
  auth: authReducer,
  contact: contactReducer,
});

export default rootReducer;
